import React, { useEffect, useState } from "react";
import { AdminPanelPage } from "../AdminPanelPage";
import { useParams } from "react-router-dom";
import { DashboardWithComponents, useDashboards } from "../../Contexts/DashboardsContext";
import { useAsyncEffect } from "../../Hooks/AsyncEffect";
import { DashboardComponentCard } from "./components/DashboardComponents/DashboardComponentCard";
import { BreadcrumbProps } from "@aidkitorg/component-library";

export const DashboardPage = () => {
  const { dashboard_id } = useParams<{ dashboard_id: string }>()

  const [dashboard, setDashboard] = useState<DashboardWithComponents>()

  const { fetchDashboardById, getDashboardById } = useDashboards()

  useAsyncEffect(async () => {
    await fetchDashboardById(dashboard_id)
  }, [])

  useEffect(() => {
    const dashboardWithComponents = getDashboardById(dashboard_id)
    if (dashboardWithComponents) {
      setDashboard(dashboardWithComponents)
    }
  }, [getDashboardById])

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: 'Dashboards',
      href: '/admin-panel/my-dashboards'
    },
    ...((!dashboard) ? [] : [{
      label: dashboard.title
    }])
  ]

  return <AdminPanelPage 
    title={dashboard?.title || ''}
    description={dashboard?.description}
    breadcrumbs={breadcrumbs}
  >
    <div className="flex flex-row flex-wrap gap-2">
      {dashboard?.components.map((component, idx) => (
        <div key={idx} className="flex-none">
          <DashboardComponentCard component={component}/>
        </div>
      ))}
    </div>
  </AdminPanelPage>
}